/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/react-in-jsx-scope */
import { Menu, styled } from '@mui/material';

const FireTvPadMenuStyled = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    backgroundColor: '#434343', // fond sombre
    color: theme.palette.primary.main, // texte blanc
    boxShadow:
      'rgba(0, 0, 0, 0.2) 0px 2px 10px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      fontSize: 15,
      '&:hover': {
        bgcolor: '#2a2a2a', // hover
      },
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: 'inherit',
        marginRight: theme.spacing(1.5),
      },
    },
  },
}));
export default FireTvPadMenuStyled;
